<div class="max-w-3xl mx-auto p-6">
    <h1 class="text-2xl font-semibold text-center text-gray-900 mb-6">
      Termos de Serviço
    </h1>
  
    <div class="space-y-4 text-base text-gray-700">
      <p>
        Ao utilizar nossos serviços, você concorda com os seguintes termos e condições.
      </p>
      <p>
        O uso deste site é sujeito a todas as leis e regulamentos aplicáveis. O usuário concorda em cumprir todas as leis locais, estaduais, nacionais e internacionais relacionadas ao uso do serviço.
      </p>
      <p>
        O conteúdo do site, incluindo, mas não se limitando a texto, gráficos, logotipos e imagens, é de propriedade exclusiva da empresa e protegido por direitos autorais.
      </p>
      <p>
        O serviço é fornecido "no estado em que se encontra", sem garantias de qualquer tipo, seja expressa ou implícita.
      </p>
      <p>
        Para mais informações, consulte nossa política de privacidade e outras seções de apoio.
      </p>
    </div>
  

  </div>
  